import { NumberInput } from '@mantine/core';
import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useEventContext } from 'Screens/Dashboard/Events/EventHandler/EntityEventContext';

const WeeklyRecurrenceInput = () => {
    const intl = useIntl();
    const { values, updateValues } = useEventContext();
    const { weekly } = values.recurrence;
    const interval = useMemo(() => {
        if (weekly?.interval) {
            return weekly.interval;
        }

        return 1;
    }, [weekly]);

    const updateEveryXWeek = (value: number | string) => {
        if (!weekly) {
            return;
        }

        const numericValue = Number(value) || 1;

        if (numericValue <= 0 || numericValue > 20) {
            return;
        }

        updateValues({
            recurrence: {
                ...values.recurrence,
                weekly: {
                    ...weekly,
                    interval: numericValue,
                },
            },
        });
    };

    return (
        <div style={{ maxWidth: '200px' }}>
            <NumberInput
                id="weekly-recurrence-input"
                label={intl.formatMessage(messages.label)}
                max={20}
                min={1}
                onChange={updateEveryXWeek}
                size="md"
                step={1}
                value={interval}
                radius="md"
                error={interval < 1 || interval > 20 ? intl.formatMessage(messages.invalid) : undefined}
            />
        </div>
    );
};

const messages = defineMessages({
    label: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventRecurrence.WeeklyRecurrenceInput.WeeklyRecurrenceInput.label',
        defaultMessage: 'Co ile tygodni?',
    },
    invalid: {
        id: 'src.Screens.Dashboard.Events.EventHandler.inputs.EventRecurrence.WeeklyRecurrenceInput.WeeklyRecurrenceInput.invalid',
        defaultMessage: 'Niepoprawna wartość',
    },
});

export default WeeklyRecurrenceInput;
